import {Button, Icon, Spinner, Text} from "@chakra-ui/react";
import {useEffect, useRef, useState} from "react";
import {HiOutlineCheck} from "react-icons/hi";

const ConfirmationButton = ({label, icon, onConfirm, variant, isLoading = false, withoutConfirmation = false, ...rest}) => {
    const [needConfirmation, setNeedConfirmation] = useState(false);
    const buttonRef = useRef(null);
    const [initialWidth, setInitialWidth] = useState(null);
    const handleClick = () => {
        (withoutConfirmation || needConfirmation) ? handleConfirm() : setNeedConfirmation(true);
    }

    useEffect(() => {
        if (!initialWidth) {
            setInitialWidth(buttonRef.current?.clientWidth);
        }
    }, []);

    useEffect(() => {
        if (needConfirmation) {
            const timer = setTimeout(() => {
                setNeedConfirmation(false);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [needConfirmation]);

    const handleConfirm = () => {
        onConfirm && onConfirm();
        setNeedConfirmation(false);
    }


    return (
        <Button ref={buttonRef} variant={variant} textDecoration='unset' minW={230}
                onClick={handleClick} disabled={isLoading} {...rest} bg={needConfirmation && "#c44f4f"}>
            {isLoading ?
                <Spinner size={'md'} color={'white'}/> :
                !needConfirmation ?
                    <>
                        {icon &&
                            <Icon fontSize={46}>
                                {icon}
                            </Icon>
                        }
                        <Text>{label}</Text>
                    </> :
                    <>
                        <Icon fontSize={46}>
                            <HiOutlineCheck/>
                        </Icon>
                        <Text>Are you sure?</Text>
                    </>
            }
        </Button>
    )
}

export default ConfirmationButton;
